module.exports = "/_next/static/images/88b21761eb75911aa01de2ae3e146acb-nubanker-xpeer@0.5x.jpg";